import React from 'react';
import MainMenu from '@components/app.chrome/main.menu';
import { Icon, IconButton } from '@material-ui/core';
import { useBool } from '@domain/hooks/use.bool';

const MainMenuButton = () => {
  const menuOpen = useBool(false);

  return (
    <>
      <IconButton edge='start' color='inherit' aria-label='main menu' aria-controls='main-menu' onClick={menuOpen.enable}>
        <Icon>menu</Icon>
      </IconButton>
      <MainMenu open={menuOpen} />
    </>
  );
};

export default MainMenuButton;
